export default __webpack_public_path__ + "static/media/indigo_logo.d46094d8.svg";